import AppPermissionsContainer from './AppPermissionsContainer'

export default function AppPermissionsScreen() {
    return <AppPermissionsContainer />
}
